/** Formik validation  */
const objIsRecord = (obj) => {
    return !!obj && typeof obj === 'object';
};
/**
 * getValidationErrors returns an array of error strings listed from a FormikErrors input object, keyed by property
 *
 * Params:
 * - errors: a FormikErrors input object
 * - prefix: used internally
 */
export const getValidationErrors = (errors, prefix = '') => {
    return Object.keys(errors).reduce((listedErrors, key) => {
        const error = errors[key];
        if (objIsRecord(error))
            listedErrors.push(...getValidationErrors(error, `${prefix}${key}.`));
        else if (error)
            listedErrors.push(`${prefix}${key}: ${error}`);
        return listedErrors;
    }, []);
};
